import {
  IsString,
  IsArray,
  IsOptional,
  IsBoolean,
  ValidateNested,
  IsNumber,
} from 'class-validator';
import { Type } from 'class-transformer';

export class WidgetPositionDto {
  @IsNumber()
  x!: number;

  @IsNumber()
  y!: number;

  @IsNumber()
  w!: number;

  @IsNumber()
  h!: number;
}

export class WidgetConfigDto {
  @IsString()
  id!: string;

  @IsString()
  type!: string;

  @IsString()
  title!: string;

  @IsString()
  size!: string;

  @ValidateNested()
  @Type(() => WidgetPositionDto)
  position!: WidgetPositionDto;

  @IsOptional()
  settings?: Record<string, unknown>;

  @IsOptional()
  @IsNumber()
  refreshInterval?: number;
}

export class DashboardLayoutDto {
  @IsString()
  id!: string;

  @IsString()
  name!: string;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => WidgetConfigDto)
  widgets!: Array<WidgetConfigDto>;

  @IsOptional()
  @IsBoolean()
  isDefault?: boolean;
}

export interface DashboardTemplateDto {
	id: string;
	name: string;
	description?: string;
	category?: string;
	widgets: Array<unknown>;
}

export type GetUserLayoutResponseDto = DashboardLayoutDto | null;

export type GetTemplatesResponseDto = Array<DashboardTemplateDto>;

export interface ApplyTemplateBodyDto {
	templateId: string;
}